module.exports = __webpack_public_path__ + "media/images/builder/download-bf5540035c9a77e570a8c357fe8a95aa.png";